// ** React Imports
import { Fragment, useEffect, memo, useState } from 'react'
import { useNavigate } from 'react-router-dom';

// ** Third Party Components
import classnames from 'classnames'

// ** Store & Actions
import { useSelector, useDispatch } from 'react-redux'
import { handleContentWidth, handleMenuCollapsed, handleMenuHidden } from '@store/layout'
import InfoLoader from '@src/views/components/infoLoader'
// ** Styles
import 'animate.css/animate.css'
import React from 'react'
import { Headphones, X } from 'react-feather';
import { FaHeadset } from 'react-icons/fa';
import Topbar from '../../../../views/components/topBar';

const LayoutWrapper = props => {
  // ** Props
  const { children, routeMeta } = props
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  // ** Store Vars
  const dispatch = useDispatch()
  const store = useSelector(state => state)

  const navbarStore = store.navbar
  const layoutStored = store.layout.layout
  const contentWidth = store.layout.contentWidth
  const transition = store.layout.routerTransition
  const hideNavBar = store.layout.hideNavBar
  const showInfoLoader = store.layout.showInfoLoader

  //** Vars
  const appLayoutCondition =
    (layoutStored.layout === 'horizontal' && !routeMeta) ||
    (layoutStored.layout === 'horizontal' && routeMeta && !routeMeta.appLayout)
  const Tag = appLayoutCondition ? 'div' : Fragment

  // ** Clean Up Function
  const cleanUp = () => {
    if (routeMeta) {
      if (routeMeta.contentWidth) {
        dispatch(handleContentWidth('full'))
      }
      if (routeMeta.menuCollapsed) {
        dispatch(handleMenuCollapsed(!routeMeta.menuCollapsed))
      }
      if (routeMeta.menuHidden) {
        dispatch(handleMenuHidden(!routeMeta.menuHidden))
      }
    }
  }

  // ** ComponentDidMount
  useEffect(() => {
    if (routeMeta) {
      if (routeMeta.contentWidth) {
        dispatch(handleContentWidth(routeMeta.contentWidth))
      }
      if (routeMeta.menuCollapsed) {
        dispatch(handleMenuCollapsed(routeMeta.menuCollapsed))
      }
      if (routeMeta.menuHidden) {
        dispatch(handleMenuHidden(routeMeta.menuHidden))
      }
    }
    return () => cleanUp()
  }, [routeMeta])

  const handleToggle = () => {
    setIsOpen(prev => !prev);

    if (!isOpen) {
      navigate('/support'); // or any route when opening
    } else {
      navigate(-1);
    }
  };

  return (
    <React.Fragment>
      {showInfoLoader && <InfoLoader />}
      <div
        className={classnames('layout-wrapper', {
          [routeMeta ? routeMeta.className : '']: routeMeta && routeMeta.className,
          'show-overlay': navbarStore.query.length,
          'app-content': !hideNavBar,
          'content': !hideNavBar
        })}
        style={{ height: "100%" }}
      >
      <Topbar />

        {/* <button className='support-btn' onClick={handleToggle} style={{
          position: 'fixed', bottom: '20px', right: '10px', zIndex: '55', fontSize: '20px',
          cursor: 'pointer', backgroundColor: '#2596be'
        }}>{isOpen ? <X /> : <FaHeadset size={28} />}</button> */}

        <div className='content-overlay'></div>
        <div className='header-navbar-shadow' />
        <div
          className={classnames({
            'content-wrapper': routeMeta && !routeMeta.appLayout,
            'content-area-wrapper': routeMeta && routeMeta.appLayout,
            'container-xxl p-0': contentWidth === 'boxed',
            [`animate__animated animate__${transition}`]: transition !== 'none' && transition.length
          })}
        >
          <Tag {...(appLayoutCondition ? { className: 'content-body' } : {})}>{children}</Tag>
        </div>
      </div>
    </React.Fragment>
  )
}

export default memo(LayoutWrapper)
